/* eslint-disable import/no-unresolved */
import React from 'react';
import { useDispatch } from 'react-redux';
import emptyWebhooksImage from 'images/empty_webhooks.png';
import { useTranslation } from 'react-i18next';

import TableMC from '../../../components/TableMC';
import TitleMC from '../../../components/TitleMC';
import ButtonMC from '../../../components/ButtonMC';
import { SIDEBAR_ACTIONS } from '../../../../constants/actionsConstants';
import EmptyScreenMC from '../../../components/EmptyScreenMC';
import usePagination from '../../../../hooks/usePagination';
import WebhookModelMC from '../../../models/WebhookModelMC';

const WebhooksListModuleMC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('WebhooksScreenMC');

  const {
    data,
    loading,
    refetch,
    paginationComponent
  } = usePagination({
    modelService: WebhookModelMC.get
  });

  const webhooks = Array.isArray(data) ? data : (data?.response || []);

  const headers = [
    { key: 'name', label: t('name_label') },
    { key: 'targetUrl', label: t('target_url_label') },
    { key: 'eventType', label: t('event_type_label') },
    { key: 'status', label: t('status') }
  ];

  const getWebhookRows = () => webhooks.map(formatWebhookRow);

  const formatWebhookRow = (webhook) => ({
    id: webhook.id,
    name: { value: webhook.name, type: 'text' },
    targetUrl: { value: webhook.target_url, type: 'text' },
    eventType: { value: webhook.event_type, type: 'text' },
    status: { value: webhook.active ? t('active') : t('inactive'), type: 'status-label' },
    actions: [createAction('edit', webhook), createAction('delete', webhook)]
  });

  const createAction = (action, webhook) => {
    switch (action) {
      case 'edit':
        return {
          icon: 'edit-outline',
          label: t('edit'),
          action: () => handleEditWebhook(webhook)
        };
      case 'delete':
        return {
          icon: 'trash-2-outline',
          label: t('delete'),
          action: () => handleDeleteWebhook(webhook.id)
        };
      default:
        return null;
    }
  };

  const handleDeleteWebhook = async (id) => {
    const confirmDelete = window.confirm(t('delete_confirmation'));
    if (confirmDelete) {
      try {
        await WebhookModelMC.remove({ id });
        refetch();
        if (window.showtoast) window.showtoast(t('webhook_deleted_success'));
      } catch (error) {
        console.error(error);
        if (window.showtoast) window.showtoast(t('webhook_delete_error'));
      }
    }
  };

  const handleEditWebhook = (webhook) => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'WebhookModal',
        closeOnOverlayClick: false,
        props: {
          webhookToEdit: webhook,
          onSuccess: refetch
        }
      }
    });
  };

  const handleCreateWebhook = () => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'WebhookModal',
        closeOnOverlayClick: false,
        props: {
          onSuccess: refetch
        }
      }
    });
  };

  const emptyComponent = (
    <EmptyScreenMC
      title="empty_screen.title"
      description="empty_screen.description"
      btnLabel="empty_screen.button_label"
      onClick={handleCreateWebhook}
      translationNS="WebhooksScreenMC"
      image={emptyWebhooksImage}
      tableEmptyScreen
    />
  );

  return (
    <div className="tw-wrapper tw-p-4">
      <div className="tw-flex tw-flex-row tw-justify-between tw-items-center tw-mb-5">
        <TitleMC
          text={t('title')}
          variant="H5"
          textClassName="tw-font-semibold"
          className="!tw-gap-1"
        />
        <ButtonMC
          text={`${t('create_webhook')} +`}
          onClick={handleCreateWebhook}
        />
      </div>

      <div className="tw-flex-col">
        <TableMC
          headers={headers}
          data={getWebhookRows()}
          borderAll
          loading={loading}
          emptyComponent={emptyComponent}
        />
        {data?.pages > 1 && (
          <div className="tw-pt-4">
            {paginationComponent}
          </div>
        )}
      </div>
    </div>
  );
};

export default WebhooksListModuleMC;

